// handleRouterChange.js
// Utility to update the router with orderBy and sortOrder as query params
// handleRouterChange.js
export function handleRouterChange(orderBy, sortOrder, navigate, location) {
  const params = new URLSearchParams(location.search);
  params.set("orderBy", orderBy);
  params.set("sortOrder", sortOrder);
  navigate(`${location.pathname}?${params.toString()}`);
}

